import type { ReviewState } from '../model.ts';

const REVIEW_TABS = [
  { value: 'pending', label: '待審查', reviewState: 'PENDING_REVIEW' },
  { value: 'rejected', label: '審核失敗', reviewState: 'REJECTED' },
  { value: 'approved', label: '審核成功', reviewState: 'APPROVED' },
  { value: 'submitted', label: '掃描中', reviewState: 'SUBMITTED' },
] as const satisfies ReadonlyArray<{
  value: string;
  label: string;
  reviewState: ReviewState;
}>;

type ReviewTabValue = (typeof REVIEW_TABS)[number]['value'];

const DEFAULT_REVIEW_TAB: ReviewTabValue = 'pending';

const isReviewTabValue = (value: string | null): value is ReviewTabValue =>
  REVIEW_TABS.some((tab) => tab.value === value);

const getReviewStateOfTab = (tab: ReviewTabValue): ReviewState =>
  REVIEW_TABS.find(({ value }) => value === tab)!.reviewState;

export {
  DEFAULT_REVIEW_TAB,
  REVIEW_TABS,
  getReviewStateOfTab,
  isReviewTabValue,
};

export type { ReviewTabValue };
